const BILLING_URL = process.env.REACT_APP_BILLING_URL || '';

const getAuthHeader = () => {
  try {
    const user = JSON.parse(localStorage.getItem('juridic_user') || '{}');
    return user.token ? `Bearer ${user.token}` : null;
  } catch {
    return null;
  }
};

export const registrarBilling = async ({ route, path, value, param, type }) => {
  try {
    const auth = getAuthHeader();
    if (!auth) return;
    await fetch(`${BILLING_URL}/billing`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': auth },
      body: JSON.stringify({ route, path, value, param, type }),
    });
  } catch (err) {
    console.warn('⚠️ Billing não registrado:', err.message);
  }
};
